import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center mb-2",
  style: {"margin-top":"-10px"}
}
const _hoisted_2 = {
  key: 2,
  class: "mt-2"
}

import {
    DataSourceConfigInterface,
    DataSourceInterface,
} from "~/cabinet/vue/client/dashboard/Interface";
import {computed} from "vue";
import MyFilter from "~/cabinet/vue/interface/filter/MyFilter.vue";
import MyCascader from "~/core-ui/vue/ui/MyCascader.vue";
import MyForm from "~/cabinet/vue/interface/form/elements/MyForm.vue";
import GroupByConfig from "~/cabinet/vue/client/dashboard/config/GroupByConfig.vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {AccountStore} from "~/cabinet/ts/store/AccountStore";
import LcabApiRequest from "~/cabinet/ts/api/LcabApiRequest";
import ReactiveRequestLoader from "~/cabinet/vue/interface/data/ReactiveRequestLoader.vue";


import {defineComponent, ref} from 'vue';
import Dictionary from "~/ts/library/Dictionary";
import {IFiltersData} from "~/cabinet/vue/interface/filter/Interfaces";
import ReactiveRequest from "~/core-ui/ts/request/ReactiveRequest";

let filtersDictionary = ref<Dictionary<ReactiveRequest<FiltersResponseInterface>>>({});


interface FiltersResponseInterface {
    filters: IFiltersData
}

const __default__ = defineComponent({
    name: "DataSourceConfig"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    isGroupByAllowed: { type: Boolean },
    dataSources: {},
    value: {},
    isManyDataSources: { type: Boolean },
    dataSourceIndex: {}
  },
  setup(__props: any) {

let props = __props;

let currentDataSource = computed(() => getDataSourceById(props.value.dataSourceId));

let currentAnalyticFunction = computed(() => {
    return currentDataSource.value.analyticFunctions.find(item => item.id == props.value.analyticFunction);
});

function getDataSourceById(id: string): DataSourceInterface | null {
    return props.dataSources.find(item => item.id == id);
}

function getFiltersKey(dataSource: DataSourceInterface) {
    return `${AccountStore.organization.value.id}_${dataSource.dashboardTypeId}_${dataSource.id}`;
}


function getFiltersRequest(dataSource: DataSourceInterface) {
    let key = getFiltersKey(dataSource);
    if (!filtersDictionary.value.hasOwnProperty(key)) {
        let request = filtersDictionary.value[key] = new ReactiveRequest<FiltersResponseInterface>(new LcabApiRequest<{
            filters: IFiltersData
        }>({
            url: `/api/client/dashboard/${dataSource.dashboardTypeId}/${dataSource.id}/getDataSourceFilters`,
            silent: true,
            silentError: false
        }), false);
        request.make();
    }
    return filtersDictionary.value[key];
}

let currentDataSourceFiltersRequest = computed(() => {
    return getFiltersRequest(currentDataSource.value);
});

async function getFiltersAsync(dataSource: DataSourceInterface): Promise<IFiltersData> {
    let request = getFiltersRequest(dataSource);
    if (request.isLoading) {
        await request.getCurrentMakePromise();
    }
    return request.data?.filters;
}

function initDateTimeVariant(dataSource: DataSourceInterface) {
    if (!dataSource.dateTimeFields.find(item => item.id == props.value.dateTimeVariantId)) {
        props.value.dateTimeVariantId = dataSource.dateTimeFields[0].id;
    }
}

if (currentDataSource.value) {
    initDateTimeVariant(currentDataSource.value);
}

async function onDataSourceChange(newDataSourceId: string) {
    let previousDataSource = getDataSourceById(props.value.dataSourceId);
    let newDataSource = getDataSourceById(newDataSourceId);
    props.value.dataSourceId = newDataSourceId;
    if (JSON.stringify(previousDataSource?.groupByList) != JSON.stringify(newDataSource?.groupByList)) {
        props.value.groupByList = [];
    }

    if (!newDataSource.analyticFunctions.find(item => item.id == props.value.analyticFunction)) {
        props.value.analyticFunction = newDataSource.analyticFunctions[0].id;
    }

    initDateTimeVariant(newDataSource);

    let previousDataSourceFilters = previousDataSource ? (await getFiltersAsync(previousDataSource)) : null;
    let newDataSourceFilters = newDataSource ? (await getFiltersAsync(newDataSource)) : null;

    if (JSON.stringify(previousDataSourceFilters) != JSON.stringify(newDataSourceFilters)) {
        props.value.segmentationFilters = {};
    }
}


/*
let conversionBaseDataSourceConfigId = computed(() => {
    let value = props.value.conversionBaseDataSourceConfigId;
    if (value && !props.configs.find(item => item.id == value)) {
        props.value.conversionBaseDataSourceConfigId = value = null;
    }
    return value;
});
*/


return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, null, {
    default: _withCtx(() => [
      (__props.isManyDataSources)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(FontAwesomeIcon, {
              class: "sortable-handler cursor-move",
              icon: "grip-horizontal"
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form, {
        "label-position": "left",
        "label-width": "160px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "Источник данных" }, {
            default: _withCtx(() => [
              _createVNode(MyCascader, {
                "model-value": __props.value.dataSourceId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (onDataSourceChange($event))),
                options: __props.dataSources
              }, null, 8, ["model-value", "options"])
            ]),
            _: 1
          }),
          (_unref(currentDataSource))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (__props.isManyDataSources)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "Название графика"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: __props.value.descr,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.value.descr) = $event)),
                          placeholder: `График #${__props.dataSourceIndex + 1}`
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, { label: "Показатель" }, {
                  default: _withCtx(() => [
                    (_unref(currentDataSource).analyticFunctions.length > 1)
                      ? (_openBlock(), _createBlock(_component_el_select, {
                          key: 0,
                          modelValue: __props.value.analyticFunction,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.value.analyticFunction) = $event)),
                          class: "w-100"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentDataSource).analyticFunctions, (analyticFunction) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: analyticFunction.id,
                                value: analyticFunction.id,
                                label: analyticFunction.descr
                              }, null, 8, ["value", "label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_unref(currentDataSource).analyticFunctions[0].descr), 1)
                        ], 64)),
                    (_unref(currentAnalyticFunction) && _unref(currentAnalyticFunction).additionalConfigForm)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createVNode(_component_el_form, { "label-position": "top" }, {
                            default: _withCtx(() => [
                              _createVNode(MyForm, {
                                form: _unref(currentAnalyticFunction).additionalConfigForm,
                                modelValue: __props.value.analyticFunctionForm,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((__props.value.analyticFunctionForm) = $event))
                              }, null, 8, ["form", "modelValue"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (_unref(currentDataSourceFiltersRequest).data?.filters || _unref(currentDataSourceFiltersRequest).isLoading)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      label: "Фильтры"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(ReactiveRequestLoader, { request: _unref(currentDataSourceFiltersRequest) }, {
                          default: _withCtx(() => [
                            _createVNode(MyFilter, {
                              "filters-data": _unref(currentDataSourceFiltersRequest).data.filters,
                              modelValue: _unref(props).value.segmentationFilters,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(props).value.segmentationFilters) = $event))
                            }, null, 8, ["filters-data", "modelValue"])
                          ]),
                          _: 1
                        }, 8, ["request"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(currentDataSource).dateTimeFields.length > 1)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      label: "Тип даты"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: __props.value.dateTimeVariantId,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((__props.value.dateTimeVariantId) = $event)),
                          class: "w-100"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentDataSource).dateTimeFields, (dateTimeField) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: dateTimeField.id,
                                value: dateTimeField.id,
                                label: dateTimeField.descr
                              }, null, 8, ["value", "label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (__props.isGroupByAllowed && _unref(currentDataSource).groupByList.length)
                  ? (_openBlock(), _createBlock(GroupByConfig, {
                      key: 3,
                      "group-by-list": _unref(currentDataSource).groupByList,
                      limit: _unref(props).value.groupLimit,
                      "onUpdate:limit": _cache[6] || (_cache[6] = ($event: any) => ((_unref(props).value.groupLimit) = $event)),
                      "group-by": _unref(props).value.groupByList,
                      "onUpdate:groupBy": _cache[7] || (_cache[7] = ($event: any) => ((_unref(props).value.groupByList) = $event))
                    }, null, 8, ["group-by-list", "limit", "group-by"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})